export const availFloors = [
	{
		floor: 'Eighth (NW)',
		availability: "AVAILABLE",
		size: '2,200',
		plan: '8th-floor-nw.png',
		thumbImg: '8th-floor-thumb.jpg',
		img: '8th-floor-img.jpg',
		dl: 'floorplans.pdf'
	},
	{
		floor: 'Eighth (NE)',
		availability: "AVAILABLE",
		size: '2,124',
		plan: '8th-floor-ne.png',
		thumbImg: '8th-floor-thumb.jpg',
		img: '8th-floor-img.jpg',
		dl: 'floorplans.pdf'
	}
];

export const mapLabels = [
	{
		label: "45 Jermyn St",
		pos: { lat: 51.508009, lng: -0.138239 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "45-jermyn-st.jpg"
	}, {
		label: "The Ritz and The Rivoli",
		pos: { lat: 51.506904, lng: -0.141276 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-hotel.png",
		imgSelected: "hotelSelected.png",
		type: "hotel",
		galleryImg: "the-ritz-restaurant.jpg"
	}/*, {
		label: "The Rivoli Bar",
		pos: { lat: 51.507304, lng: -0.141354 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-bar.png",
		imgSelected: "barSelected.png",
		pinNumb: 3,
		type: "bar",
		galleryImg: "the-rivoli-bar.jpg"
	}*/, {
		label: "Brown's Hotel",
		pos: { lat: 51.509131, lng: -0.142115 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-hotel.png",
		imgSelected: "hotelSelected.png",
		type: "hotel",
		galleryImg: "browns-hotel.jpg"
	}, {
		label: "Caviar House & Prunier",
		pos: { lat: 51.507769, lng: -0.140043 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "caviar-house.jpg"
	}, {
		label: "Langan's Brasserie",
		pos: { lat: 51.507044, lng: -0.143452 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "langans-brassierie.jpg"
	}, {
		label: "Novikov Restaurant",
		pos: { lat: 51.50767, lng: -0.142922 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "novikov-restaurant.jpg"
	}, {
		label: "Sexy Fish",
		pos: { lat: 51.509332, lng: -0.144346 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "sexy-fish.jpg"
	}, {
		label: "The May Fair Hotel",
		pos: { lat: 51.508159, lng: -0.143902 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-hotel.png",
		imgSelected: "hotelSelected.png",
		type: "hotel",
		galleryImg: "the-may-fair-hotel.jpg"
	}, {
		label: "The Arts Club",
		pos: { lat: 51.508329, lng: -0.142357 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-bar.png",
		imgSelected: "barSelected.png",
		type: "bar",
		galleryImg: "the-arts-club.jpg"
	}, {
		label: "Berkeley Square",
		pos: { lat: 51.509654, lng:  -0.145860 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-featured.png",
		imgSelected: "featuredSelected.png",
		type: "featured",
		galleryImg: "berkeley-square.jpg"
	}, {
		label: "Gymkhana",
		pos: { lat: 51.5086, lng: -0.141464 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "gymkhana.jpg"
	}, {
		label: "Jack Barclay Bentley",
		pos: { lat: 51.5101, lng: -0.145304 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-featured.png",
		imgSelected: "featuredSelected.png",
		type: "featured",
		galleryImg: "jack-barclay-bentley.jpg"
	}, {
		label: "Le Caprice",
		pos: { lat: 51.5064, lng: -0.140638 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "le-caprice.jpg"
	}, {
		label: "Nobu",
		pos: { lat: 51.508476, lng: -0.143417 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "nobu.jpg"
	}, {
		label: "The Wolseley",
		pos: { lat: 51.507645, lng: -0.140926 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-restaurant.png",
		imgSelected: "restaurantSelected.png",
		type: "restaurant",
		galleryImg: "the-wolseley.jpg"
	}, {
		label: "Green Park",
		pos: { lat: 51.5056, lng: -0.1433 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-featured.png",
		imgSelected: "featuredSelected.png",
		type: "featured",
		galleryImg: "green-park.jpg"
	}, {
		label: "Bond Street",
		pos: { lat: 51.509862, lng: -0.141802 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-featured.png",
		imgSelected: "featuredSelected.png",
		type: "featured",
		galleryImg: "bond-street.jpg"
	}, {
		label: "Joseph",
		pos: { lat: 51.5130399, lng: -0.1480241 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-featured.png",
		imgSelected: "featuredSelected.png",
		type: "featured",
		galleryImg: "joseph.jpg"
	}, {
		label: "Louis Vuitton",
		pos: { lat: 51.5119813, lng: -0.1461567 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-featured.png",
		imgSelected: "featuredSelected.png",
		type: "featured",
		galleryImg: "louis-vutton.jpg"
	}, {
		label: "Prada",
		pos: { lat: 51.509160, lng:  -0.141062 },
		size: { width: 35, height: 35 },
		color: "#CE9757",
		selectedColor: "#3E3D3C",
		img: "icon-featured.png",
		imgSelected: "featuredSelected.png",
		type: "featured",
		galleryImg: "prada.jpg"
	}
];

export const amenityGallery = [
	{
		img: "45-jermyn-st.jpg"
	}, {
		img: "the-ritz-restaurant.jpg"
	}/*, {
		img: "the-rivoli-bar.jpg"
	}*/, {
		img: "browns-hotel.jpg"
	}, {
		img: "caviar-house.jpg"
	}, {
		img: "langans-brassierie.jpg"
	}, {
		img: "novikov-restaurant.jpg"
	}, {
		img: "sexy-fish.jpg"
	}, {
		img: "the-may-fair-hotel.jpg"
	}, {
		img: "the-arts-club.jpg"
	}, {
		img: "berkeley-square.jpg"
	}, {
		img: "gymkhana.jpg"
	}, {
		img: "jack-barclay-bentley.jpg"
	}, {
		img: "le-caprice.jpg"
	}, {
		img: "nobu.jpg"
	}, {
		img: "the-wolseley.jpg"
	}, {
		img: "green-park.jpg"
	}, {
		img: "bond-street.jpg"
	}, {
		img: "joseph.jpg"
	}, {
		img: "louis-vutton.jpg"
	}, {
		img: "prada.jpg"
	}
];

export const staticMapLabels = [
	{
		label: 'Green Park',
		pos: { lat: 51.503901, lng: -0.143834 },
		size: { width: 99, height: 27 },
		img: 'greenpark-label.png'
	},
	{
		label: 'Golden Square',
		pos: { lat: 51.511639, lng: -0.13718 },
		size: { width: 99, height: 27 },
		img: 'goldensquare-label.png'
	},
	{
		label: 'Berkeley Square',
		pos: { lat: 51.509639, lng: -0.145877 },
		size: { width: 126, height: 27 },
		img: 'berkeley-label.png'
	},
	{
		label: 'The Ritz',
		pos: { lat: 51.507, lng: -0.1395 },
		size: { width: 99, height: 27 },
		img: 'theritz-label.png'
	},
	{
		label: 'Piccadilly Circus',
		pos: { lat: 51.5094, lng: -0.134766 },
		size: { width: 112, height: 27 },
		color: '#0D5071',
		img: 'piccadilly-label.png'
	},
	{
		label: 'St James Park',
		pos: { lat: 51.503, lng: -0.137 },
		size: { width: 112, height: 27 },
		img: 'StJamesPark.png'
	}
	// {
	// 	label: "Grovesnor Square",
	// 	pos: { lat: 51.5121, lng: -0.1493 },
	// 	size: { width: 112, height: 27 },
	// 	color: "#0D5071",
	// 	selected: 0,
	// 	selectedColor: "#C88F4D",
	// 	img: "GrosvenorSquare.png",
	// 	pinNumb: 7
	// }
];

export const availabilityLabels = [
	{
		label: '45 Jermyn St',
		pos: { lat: 51.508009, lng: -0.138239 },
		size: { width: 99, height: 27 },
		color: '#CE9757',
		selected: 1,
		selectedColor: '#3E3D3C',
		img: 'icon-restaurant.png',
		imgSelected: 'restaurantSelected.png',
		pinNumb: 1,
		type: 'restaurant'
	}
];

export const availabilityGallery = [
	{
		img: '8th-floor-1.jpg',
		label: '8th Floor'
	},
	{
		img: '8th-floor-4.jpg',
		label: '8th Floor'
	},
	{
		img: '8th-floor-5.jpg',
		label: '8th Floor'
	},
	{
		img: 'floorplan-2.jpg',
		label: 'CGI Fit out'
	},
	{
		img: 'floorplan-3.jpg',
		label: 'CGI Fit out'
	},
	{
		img: 'floorplan-4.png',
		label: 'CGI Fit out'
	},
	{
		img: 'floorplan-5.jpg',
		label: 'CGI Fit out'
	},
];



// WEBPACK FOOTER //
// ./src/data.js